import { Component, OnInit, ViewChild, ViewEncapsulation, AfterViewInit  } from '@angular/core';
import { QrScannerComponent } from 'angular2-qrscanner';
import {ActivatedRoute, Router} from "@angular/router";
import { CaptureService } from "src/app/services/Capture.service";
import { ICapture } from "src/app/interfaces/capture";

@Component({
  selector: 'app-codigo-qr',
  templateUrl: './codigo-qr.component.html',
  styleUrls: ['./codigo-qr.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CodigoQrComponent implements OnInit, AfterViewInit {

  decodedOutput(text: string) {
    console.log(text);
}

  @ViewChild(QrScannerComponent, { static: false }) qrScannerComponent: QrScannerComponent;
  capture;
  public dataCapture: ICapture;
  barcodeValue;
  cedula: string;



  constructor(
    private router: Router,
    private captureService: CaptureService,
    private _ac: ActivatedRoute,
  ) {
    this.capture =  this._ac.snapshot.data.resolData;
    //this.capture =  this._ac.snapshot.data.resolData;
    console.log(this.capture );
    this.cedula='1097994330';
  }



  ngOnInit() {





}


  ngAfterViewInit(): void {

    // this.qrScannerComponent.getMediaDevices().then(devices => {
    //   console.log(devices);
    //   const videoDevices: MediaDeviceInfo[] = [];
    //   for (const device of devices) {
    //     if (device.kind.toString() === 'videoinput') {
    //       videoDevices.push(device);
    //     }
    //   }
    //   if (videoDevices.length > 0) {
    //     let choosenDev;
    //     for (const dev of videoDevices) {
    //       if (dev.label.includes('front')) {
    //         choosenDev = dev;
    //         break;
    //       }
    //     }
    //     //if (choosenDev) {
    //      // this.qrScannerComponent.chooseCamera.next(choosenDev);
    //     //} else {
    //       this.qrScannerComponent.chooseCamera.next(videoDevices[0]);
    //     //}
    //   }
    // });

    // this.qrScannerComponent.capturedQr.subscribe(result => {
    //   this.cedula=result;
    //   console.log(result);
    // });

   // this.qrScannerComponent.startScanning(null);

   // *** Use this code, if you want to define the used device ***
   this.qrScannerComponent.getMediaDevices().then(devices => {
    console.log(devices);
    const videoDevices: MediaDeviceInfo[] = [];
    for (const device of devices) {
        if (device.kind.toString() === 'videoinput') {
            videoDevices.push(device);
        }
    }
    if (videoDevices.length > 0){
        let choosenDev;
        for (const dev of videoDevices){
            if (dev.label.includes('front')){
                choosenDev = dev;
                break;
            }
        }
        //if (choosenDev) {
            //this.qrScannerComponent.chooseCamera.next(choosenDev);
        //} else {
            this.qrScannerComponent.chooseCamera.next(videoDevices[0]);
       // }
    }
});

this.qrScannerComponent.capturedQr.subscribe(result => {
    console.log(result);
    // this.qrScannerComponent.stopScanning();
});


  }

  mostrar() {
    this.dataCapture = {
      'id_planta': this.capture.id_planta,
      'cedula':this.cedula,
      'orden_ceco':this.capture.orden_ceco,
      'linea':this.capture.linea,
      'filtro_linea':this.capture.filtro_linea,
      'latitude':this.capture.latitude,
      'longitude':this.capture.longitude,
      'showSalida':this.capture.showSalida,
      'entrega':this.capture.entrega,
      'observaciones':this.capture.observaciones
    }
    this.captureService.addCapture(this.dataCapture);
   // publi cedua=2525663
    this.router.navigate(['/capture']);

  }

}
